:host {
  display: block;
  width: 100%;
  text-align: var(--sy-blog-img-text-align, center);

  img {
    width: var(--sy-blog-img-width, auto);
    border-radius: inherit;
    max-width: 100%;
  }
}
